import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import {LocalStorageService} from 'ngx-webstorage';
//import { connect } from '../../assets/amazon-connect-chat-interface';
declare var connect: any;
@Component({
  selector: 'app-chat-ui',
  templateUrl: './chat-ui.component.html',
  styleUrls: ['./chat-ui.component.css']
})
export class ChatUiComponent implements OnInit {

  constructor(private storage:LocalStorageService) { }
  connect: any;
  customerName:string="";
  quoteId:string="";
  ngOnInit() {
    //let connect:any;
    this.customerName = this.storage.retrieve("username");
    this.quoteId = this.storage.retrieve('quoteId') || "";
    $(function () {
      connect.ChatInterface.init({
        containerId: 'root' // This is the id of the container where you want the widget to reside
      });

      $('#contactDetails').submit(function (e) {
        e.preventDefault();

        var customerName = $('#firstName').val();
        var quoteId = $('#quoteId').val() || "";
        console.log('in the submit function')
          //var contactFlowId = "92612429-500a-4063-9687-ed77fde288ee"; // TODO: Fill in
        var contactFlowId = "b797b1da-d4c6-40ca-9dec-24ce58dcbedb"
        var instanceId = "98164f61-9e3a-4d6e-b567-e1d1cf4f2c54"; // TODO: Fill in
        var apiGatewayEndpoint = "https://xqenmxl1w9.execute-api.us-east-1.amazonaws.com/Prod/"; // TODO: Fill in with the API Gateway endpoint created by your CloudFormation template

        console.log("this is the first name:" + customerName);
        //document.getElementById("contactDetails").reset();

        connect.ChatInterface.initiateChat({
          name: customerName,
          region: "us-east-1", // TODO: fill in
          apiGatewayEndpoint: apiGatewayEndpoint,
          contactAttributes: JSON.stringify({
            "customerName": customerName,
            "username": customerName,
            "quoteId":quoteId
          }),
          contactFlowId: contactFlowId,
          instanceId: instanceId
        },     function successHandler(chatSession) {
          console.log("success!");
          $('#chat-button').hide()
          $('#section-chat').fadeIn(400);

          chatSession.onChatDisconnected(function (data) {
            $('#section-chat').hide();
            $('#chat-button').show()
          });
        },     function failureHandler(error) {
          console.log("There was an error: ");
          console.log(error);
        });


      });
    });




  }
}
